import React from 'react';

import { Breadcrumb } from '../../components/Breadcrumb';
import { IconButton } from '../../components/IconButton';

// 仮アイコン（ユーザー）: 既存 public 配下アイコンがあれば差し替え可能
const iconUser = '/figma_asset/UserWhite.svg';

interface CompanyRow {
  id: string;
  name: string;
  manager: string;
  users: string;
  simpleCheckRate: string;
  cpapUsers: string;
  contractStart: string;
  contractEnd: string;
  isNew?: boolean;
}

const notifications = [
  {
    id: 'n1',
    date: '2025.08.20',
    text: '株式会社オープンハウスグループが患者リストをアップロードしました。',
  },
  {
    id: 'n2',
    date: '2025.08.20',
    text: 'サカタのタネ株式会社が患者リストをアップロードしました。',
  },
];

const companies: CompanyRow[] = [
  {
    id: 'c1',
    name: '株式会社オープンハウスグループ',
    manager: '山本恒二',
    users: '200人',
    simpleCheckRate: '80%',
    cpapUsers: '20人',
    contractStart: '2025.08.01',
    contractEnd: '2025.08.05',
    isNew: true,
  },
  {
    id: 'c2',
    name: 'サカタのタネ株式会社',
    manager: '山本恒二',
    users: '200人',
    simpleCheckRate: '80%',
    cpapUsers: '20人',
    contractStart: '2025.08.01',
    contractEnd: '2025.08.05',
  },
  {
    id: 'c3',
    name: '株式会社ニッスイ',
    manager: '山本恒二',
    users: '200人',
    simpleCheckRate: '80%',
    cpapUsers: '20人',
    contractStart: '2025.08.01',
    contractEnd: '2025.08.05',
  },
  {
    id: 'c4',
    name: 'マルハニチロ株式会社',
    manager: '山本恒二',
    users: '200人',
    simpleCheckRate: '80%',
    cpapUsers: '20人',
    contractStart: '2025.08.01',
    contractEnd: '2025.08.05',
  },
];

const ManageCompanyPage: React.FC = () => {
  return (
    <div className="flex flex-col w-full gap-[40px]">
      {/* breadcrumb */}
      <Breadcrumb
        items={[{ label: 'ホーム', href: '/dashboard' }, { label: '企業リスト' }]}
        // Use text separator '＜' consistent with current design
        separator="＜"
        showLeadingSeparator
        className="mb-0"
      />

      {/* title & action */}
      <div className="flex items-center justify-between w-full">
        <h1 className="text-[28px] font-medium text-black leading-none">企業管理</h1>
        <IconButton
          label="新規登録"
          iconSrc="/figma_asset/Plus square.svg"
          iconAlt="新規登録"
          iconPosition="left"
          variant="primary"
        />
      </div>

      {/* notifications summary */}
      <div className="flex flex-col gap-[8px] bg-white border border-[#bcbcbc] rounded px-[30px] py-[20px]">
        {notifications.map((n) => (
          <div key={n.id} className="flex gap-[20px] flex-wrap items-start text-[16px]">
            <span className="text-[#ff7a7a] font-bold">NEW</span>
            <span>{n.date}</span>
            <span>{n.text}</span>
          </div>
        ))}
      </div>

      {/* table header */}
      <div className="bg-white flex items-center gap-[20px] w-full px-[15px] py-[10px] text-[14px]">
        <div className="w-[50px]" />
        <div className="w-[300px]">企業名</div>
        <div className="flex-1">企業担当者</div>
        <div className="flex-1">ユーザー数</div>
        <div className="flex-1">簡易検査達成度</div>
        <div className="flex-1">CPAP治療者数</div>
        <div className="flex-1">契約開始日</div>
        <div className="flex-1">契約終了日</div>
      </div>

      {/* rows */}
      <div className="flex flex-col w-full gap-[12px]">
        {companies.map((c) => (
          <div
            key={c.id}
            className="bg-white flex items-center gap-[20px] w-full px-[20px] py-[12px] border border-black/20"
          >
            <div className="w-[50px] flex items-center justify-center">
              {c.isNew && <span className="text-[16px] font-bold text-[#ff7a7a]">NEW</span>}
            </div>
            <div className="w-[300px] text-[16px]">{c.name}</div>
            <div className="flex-1 flex items-center gap-[8px] text-[16px]">
              <div className="w-[33px] h-[33px] rounded-[32px] bg-[#b3b3b3] flex items-center justify-center">
                <img src={iconUser} alt="user" className="w-[20px] h-[20px]" />
              </div>
              <span>{c.manager}</span>
            </div>
            <div className="flex-1 text-[16px]">{c.users}</div>
            <div className="flex-1 text-[16px]">{c.simpleCheckRate}</div>
            <div className="flex-1 text-[16px]">{c.cpapUsers}</div>
            <div className="flex-1 text-[16px] whitespace-nowrap">{c.contractStart}</div>
            <div className="flex-1 text-[16px] whitespace-nowrap">{c.contractEnd}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageCompanyPage;
